import axios from 'axios'


export default function (context) {
  if (context.state.load.data) return;
  setTimeout(() => {
    let data = context.getters.data;
    if (!data) return;
    if (context.getters.disabled_contragent_type.filter(i => i === context.state.form.ContragentType)[0]) {
      window.app.$notify({
        type: "error",
        message: 'У Вас отсутствуют права для работы с данным типом контрагентов'
      });
      return;
    }
    let url = '';
    switch (context.state.system.type) {
      case 'pay':
        url = '/tourclient/payment/' + (context.state.form.Id ? 'update' : 'add');
        if (context.state.form.Sum < context.getters['regulars/spreads']) {
          window.app.$notify.warning({
            message: 'Сумма оплаты не может быть меньше суммы распределения по требованиям',
          });
          return;
        }
        break;
      case 'regular':
        if (context.state.system.action === 'invoice' && context.state.form.Sum > context.getters['invoices/sum']) {
          window.app.$notify.warning({
            message: 'Сумма требования не может быть больше суммы счёта',
          });
          return;
        }
        url = '/tourclient/payment/regular';
        data.CreatedDate = {Serialized: context.state.system.createDate ? context.state.system.createDate : new Date().toStringRu()};
        break;
      case 'invoice':
        url = '/tourclient/payment/invoice';
        break;
      default:
        return;
    }
    context.commit('set_load', {
      data: true,
    });
    const onlineCash = {};
    if (context.state.form.addCashCheck) {
      onlineCash.OnlineCashId = context.state.form.OnlineCashId;
      onlineCash.BillProvideTypeId = context.state.form.BillProvideTypeId;
    }
    // лютый костыль для представления значений списков доп. описаний
    // впрочем, ничего необычного - у нас ведь все доп. описания являются костылями
    let addValues = JSON.parse(JSON.stringify(context.state.form.AdditionalValues));
    addValues.forEach(addVal => {
      if (addVal.AdditionalValueTypeId == 4){
        addVal.SelectedOptions = [ addVal.Value ];
      }
      if (addVal.AdditionalValueTypeId == 5 && addVal.SelectedOptions){
        let splittedValues = "";
        addVal.SelectedOptions.forEach(function (val) {
          if (splittedValues.length > 0) {
            splittedValues += ',';
          }
          splittedValues += val;
        });
        addVal.Value = splittedValues;
      }
    });
    axios({
      method: 'post',
      url,
      data: 'request=' + encodeURIComponent(JSON.stringify({
        PaymentItem: data,
        ...onlineCash,
        AdditionalValues: addValues
      }))
    }).then(r => {
      if (r.data.ResultQueryInfo && r.data.ResultQueryInfo.HasError) {
        window.app.$notify.warning({
          message: r.data.ResultQueryInfo.UserMessages,
        });
        if(!(r.data.Id > 0)){
          context.commit('set_load', {
            data: false,
          });
          return;
        }
      }
      context.state.system.saveId = r.data.Id;
      let id = context.state.files.data.paymentId;
      if (context.state.form.addCashCheck && r.data.FiskalOperationId) {
        id = id ? id : r.data.Id;
        const updateStatus = function (OnlineCashId, FiskalOperationId){
          axios
            .get(`/tourclient/api/onlinecash/document/${OnlineCashId}/${FiskalOperationId}`)
            .then(({data})=>{
              switch (data.OperationStatusId) {
                case 1:
                  setTimeout(()=>{
                    updateStatus(OnlineCashId, FiskalOperationId);
                  }, 1000);
                  return;
                case 2:
                  window.app.$notify.success({
                    message: `Чек успешно ${context.state.form.BillProvideTypeId === 2 || context.state.form.BillProvideTypeId === 3 ? 'отправлен' : 'распечатан'}`,
                  });
                  break;
                case 3:
                  window.app.$notify.warning({
                    message: data.ResultQueryInfo.UserMessages,
                  });
                  break;
              }
              context.dispatch('files/save', id);
            })
            .catch(()=>{
              window.app.$notify.warning({
                message: 'Ошибка в проведении чека',
              });
              context.dispatch('files/save', id);
            });
        };
        updateStatus(context.state.form.OnlineCashId, r.data.FiskalOperationId);
      } else {
        switch (context.state.system.type) {
          case 'payment':
            break;
          case 'regular':
          case 'invoice':
            id = id ? id : r.data.Item.Id;
            break;
        }
        if (context.state.files.data.paymentId) {
          context.dispatch('get_local');
        } else {
          context.dispatch('files/save', id);
        }
      }
    });
  }, 10);
}
